import React from 'react';
import Skeleton from '@/components/ui/Skeleton/Skeleton';
import cn from '@/utils/cn';
import StatusBoxSkeleton from './StatusBox/StatusBoxSkeleton';

// AIDEV-NOTE: #f9f9f9 mirrors the hardcoded header background in questionCard.module.scss so the
// skeleton matches the real header 1:1. The hex has no shared token today; consolidating it
// across SCSS + Tailwind is a palette-refactor follow-up, out of scope for this file.
const GREY_BORDER = 'tw-box-border tw-border tw-border-solid tw-border-med-grey tw-rounded-lg';

const FilterPillSkeleton = () => (
  <div className="tw-flex tw-flex-col tw-gap-1">
    <Skeleton height="tw-h-3" width="tw-w-16" />
    <Skeleton height="tw-h-8" width="tw-w-28" />
  </div>
);

const HeaderSkeleton = () => (
  <div className={cn('tw-bg-[#f9f9f9]', GREY_BORDER, 'tw-p-5')} data-testid="grading-skeleton-header">
    <div className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-w-full">
      <div className="tw-flex tw-flex-row tw-items-center tw-gap-3">
        <Skeleton height="tw-h-5" width="tw-w-48" />
        <Skeleton height="tw-h-5" width="tw-w-56" />
      </div>
      <Skeleton height="tw-h-5" width="tw-w-60" />
    </div>

    <div className="tw-flex tw-gap-2.5 tw-pt-4">
      <div className={cn('tw-flex tw-flex-row tw-basis-2/3 lg:tw-basis-4/5', GREY_BORDER, 'tw-py-2.5 tw-px-4')}>
        <div className="tw-pr-6 tw-pt-5">
          <Skeleton height="tw-h-5" width="tw-w-14" />
        </div>
        <div className="tw-w-full">
          <div className="tw-flex tw-gap-3 tw-mb-2">
            <FilterPillSkeleton />
            <FilterPillSkeleton />
          </div>
          <div className="tw-flex tw-gap-3">
            <FilterPillSkeleton />
            <FilterPillSkeleton />
            <FilterPillSkeleton />
            <FilterPillSkeleton />
            <FilterPillSkeleton />
          </div>
        </div>
      </div>
      <div className={cn('tw-basis-1/3 lg:tw-basis-1/5', GREY_BORDER, 'tw-py-2.5 tw-px-4')}>
        <StatusBoxSkeleton />
      </div>
    </div>
  </div>
);

export default HeaderSkeleton;
